
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';

function BotCard({ bot_id, bot_photo, bot_name, duration, bot_amount, bot_level }) {
    const { user } = useUser();
    const [loading, setLoading] = useState(false);
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);

    const ValidateBot = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/bots.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({ purchase_bot: true, bot_id: bot_id })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "dashboard";
                }, 2000);
            }else{
                toast.error(data.message);
            }
            setLoading(false);
        })
        .catch(err => {
            console.error(err)
            setLoading(false);
            toast.error('There was an issue processing your purchase.')
        })
    }

    return (
      <div className="mycard mb-4">
        <div className="d-flex align-items-center flex-column">
            <div className="d-flex align-items-center justify-content-center overflow-hidden rounded-circle" style={{width: '100px', height: '100px'}}>
                {bot_photo}
            </div>
            <p className="text-white mb-0 mt-2" style={{fontSize: '28px', fontWeight:'900'}}>{bot_name}</p>
            <p className="text-prime mb-1" style={{fontSize: '18px', fontWeight:'900', lineHeight:'100%'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(bot_amount * rate)}</p>
        </div>
        <div className="row">
            <div className="col-6 g-3">
                <div className="rounded-2 px-3 pt-2 pb-1" style={{border:'1px solid #ffffff18'}}>
                    <p className="mb-0 fw-bold text-secondary">Duration</p>
                    <p className="mb-0 fw-bold text-white">{duration}</p>
                </div>
            </div>
            <div className="col-6 g-3">
                <div className="rounded-2 px-3 pt-2 pb-1" style={{border:'1px solid #ffffff18'}}>
                    <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px',lineHeight:'100%'}}>Bot Level</p>
                    <p className="mb-0 fw-bold text-white" style={{fontSize:'20px'}}>{bot_level}%</p>
                </div>
            </div>
        </div>
        <div className={`myBtn ${(bot_id == user?.purchase_bot) ?'bg-danger':'bg-prime'} w-100 text-center mt-4`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={ValidateBot}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:(bot_id == user?.purchase_bot)?'In Use':'Purchase'}</div>
      </div>
    )
  }
  
  export default BotCard